import _ from "lodash";
import { useEffect, useState } from "react";
import { AutocompleteArrayInput } from "react-admin";
import { useField } from "react-final-form";

interface IAutocompleteManageStudentsInput {
  routeLocationData: any;
  selectedStudentIds: number[];
  allStudents: IStudent[];
  setSearchValue: any;
  setValues: any;
}

const AutocompleteManageStudentsInput = ({
  routeLocationData,
  selectedStudentIds,
  allStudents,
  setSearchValue,
  setValues,
}: IAutocompleteManageStudentsInput) => {
  const [availableStudents, setAvailableStudents] = useState<IStudent[]>([]);

  const studentIds = useField("studentIds");

  useEffect(() => {
    const studentIdsValue = routeLocationData.students.map(
      (student: IStudent) => {
        return student.id;
      }
    );

    studentIds.input.onChange(studentIdsValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeLocationData]);

  useEffect(() => {
    setAvailableStudents([...allStudents, ...routeLocationData.students]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStudentIds, allStudents]);

  return (
    <AutocompleteArrayInput
      source="studentIds"
      label=" "
      choices={availableStudents.map((student: IStudent) => ({
        id: student.id,
        name: `${student.firstName} ${student.lastName}`,
      }))}
      onInputValueChange={(searchValue: string) => {
        setSearchValue(searchValue);
      }}
      onChange={(values: any) => {
        setValues(values);
      }}
    />
  );
};

export default AutocompleteManageStudentsInput;
